export default __webpack_public_path__ + "static/media/photo19.bf443f5a.jpg";